/**
 * HealthDot — colored circle with subtle glow for deal health status.
 *
 * COORD-26: Maps health labels to static colors (same in both themes).
 */
const HEALTH_COLORS = {
  Healthy: "#22c55e",
  Watch: "#f59e0b",
  "At Risk": "#ef4444",
  Critical: "#ef4444",
};

export default function HealthDot({ health, size = 8 }) {
  const color = HEALTH_COLORS[health] || "#94a3b8";

  return (
    <span
      className="inline-block rounded-full flex-shrink-0"
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        boxShadow: health === "Critical" ? `0 0 6px ${color}` : "none",
      }}
    />
  );
}
